import { createReducer, on } from "@ngrx/store"
import { setGeneralValues } from "./general.actions"

export type GeneralState = {
    unityId?: any,
    companyId?: any
}

const initialState: GeneralState = {}

export const generalReducer = createReducer(
    initialState,
    on(
        setGeneralValues,
        (state, { values }) => ({
            ...state,
            ...values
        })
    )
)
